import Component from '@glimmer/component';
import { service } from '@ember/service';
import { on } from '@ember/modifier';
import type Lightbox from '../../services/lightbox';
import ImageViewer from './image-viewer.gts';
import Icon from '../icon';
import XIcon from '~icons/lucide/x';

interface ContainerSignature {
  Args: {};
  Element: HTMLDivElement;
}

export default class Container extends Component<ContainerSignature> {
  @service declare lightbox: Lightbox;

  <template>
    {{#if this.lightbox.state}}
      <div
        class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/95"
        role="dialog"
        aria-modal="true"
        aria-label="Image viewer"
      >
        {{! Close button }}
        <button
          type="button"
          class="btn btn-circle absolute top-[calc(1rem+env(safe-area-inset-top,0px))] right-[calc(1rem+env(safe-area-inset-right,0px))] z-10 border-white/80 bg-white/80 text-black"
          aria-label="Close"
          {{on "click" this.lightbox.close}}
        >
          <Icon @icon={{XIcon}} class="h-6 w-6" />
        </button>

        {{! Image viewer }}
        <ImageViewer
          @imageUrl={{this.lightbox.state.imageUrl}}
          @altText={{this.lightbox.state.altText}}
        />

        {{! Backdrop click to close }}
        <div
          class="absolute inset-0 z-[-1]"
          role="button"
          aria-label="Close lightbox"
          {{on "click" this.lightbox.close}}
        ></div>
      </div>
    {{/if}}
  </template>
}
